module.exports = __webpack_public_path__ + "img/slogan.a2989a72.png";